export const DataAttributesConstant = {
  favoritesManager: "data-favorites-manager",
  favoritesTypeSection: "data-favorites-type-section",
  favoritesType: "data-favorites-type",
  favoritesParams: "data-favorites-params",
};
